import { useMutation } from 'react-query'
import { api } from '../services/api'
import { useToast } from '@chakra-ui/react'

async function getReceitaFederal(cnpj) {
  const response = await api.get(`/site/v2/pedido/busca-dados-receita/${cnpj}`)
  return response.data
}

export const useReceitaFederal = () => {
  const toast = useToast({
    status: 'error',
    position: 'top-right',
    duration: 5000,
  })

  async function handleCnpj(cnpj) {
    await mutateAsync(cnpj)
  }

  const { mutateAsync, data, isLoading, error } = useMutation({
    mutationFn: (cnpj) => getReceitaFederal(cnpj),
    onError: (error) => {
      console.log(error)
      toast({
        title: 'Erro!',
        description: error.response.data.erros.join(', '),
        status: 'error',
        duration: 5000,
        isClosable: true,
      })
    },
  })

  return { data, isLoading, error, handleCnpj }
}
